class CollectionFilter {
    constructor (theme, elem) {
        this.name = 'CollectionFilter'
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        const applyButton = this._elem.querySelectorAll('[data-apply]')
        if (applyButton.length > 0) {
            applyButton.forEach(button => { button.addEventListener('click', (e) => { e.preventDefault(); this.applyFilters() }) })
        }
        const resetButton = this._elem.querySelectorAll('[data-reset]')
        if (resetButton.length > 0) {
            resetButton.forEach(button => { button.addEventListener('click', (e) => { e.preventDefault(); this.resetFilters() }) })
        }
        this.setupTitle()

        const header = this._elem.querySelector('[data-filter-header]')
        if (header) {
            header.addEventListener('click', () => { this.toggleModal() })
        }
        document.body.addEventListener('click', (e) => { this.checkOuterClick(e) })

        const parentButtons = this._elem.querySelectorAll('[data-parent]')
        if (parentButtons.length > 0) {
            parentButtons.forEach(button => {
                button.addEventListener('click', (e) => { e.preventDefault(); this.goToChild(button) })
            })
        }
        const childButtons = this._elem.querySelectorAll('[data-back]')
        if (childButtons.length > 0) {
            childButtons.forEach(button => {
                button.addEventListener('click', (e) => { e.preventDefault(); this.goToParent() })
            })
        }
        const backButton = this._elem.querySelector('[data-filter-back]')
        if (backButton) {
            backButton.addEventListener('click', () => { this.closeModal() })
        }
        const options = this._elem.querySelectorAll('input[data-filter-option]')
        if (options.length > 0) {
            for (let option of options) {
                option.addEventListener('change', (e) => { this.resetOtherFilters(e); this.applyFilters() })
            }
        }
    }
    setupTitle () {
        const filters = this._elem.querySelectorAll('[data-filter-option]')
        const currentFilter = this._elem.querySelector('[data-current-filter]')
        let names = []
        if (filters.length > 0) {
            for (var i = 0; i < filters.length; i++) {
                if (filters[i].checked) {
                    names.push(filters[i].dataset.title)
                }
            }
            if (names.length > 0) {
                if (names.length === 1) {
                    currentFilter.textContent = names[0]
                } else {
                    currentFilter.textContent = `${names.length} Selected`
                }
            } else {
                currentFilter.textContent = 'All'
            }
        }
    }
    checkOuterClick (e) {
        if (window.innerWidth > 768) {
            if (this._elem !== e.target && this._elem.contains(e.target)) {
            } else {
                this.closeModal()
            }
        }
    }
    toggleModal () {
        const thisModal = this._elem.querySelector('[data-filter-modal]')
        if (thisModal) {
            thisModal.classList.contains('active') ? this.closeModal() : this.openModal()
        }
    }
    openModal () {
        const thisModal = this._elem.querySelector('[data-filter-modal]')
        const otherModals = document.querySelectorAll('[data-filter-modal]')
        const mobileParent = document.querySelector('[data-collection-mobile-parent]')
        if (thisModal && otherModals.length > 0 && mobileParent) {
            otherModals.forEach(modal => {
                modal.classList.remove('active')
            })
            thisModal.classList.add('active')
            this._elem.classList.add('active')
            mobileParent.classList.add('active')
        }
    }
    closeModal () {
        const thisModal = this._elem.querySelector('[data-filter-modal]')
        const mobileParent = document.querySelector('[data-collection-mobile-parent]')
        if (thisModal && mobileParent) {
            thisModal.classList.remove('active')
            this._elem.classList.remove('active')
            mobileParent.classList.remove('active')
            this.goToParent()
        }
    }
    goToChild (parent) {
        const children = this._elem.querySelectorAll('[data-child-of]')
        const parentContainer = this._elem.querySelector('[data-filter-parents]')
        if (children.length > 0) {
            children.forEach(child => {
                child.classList.remove('active')
                if (child.dataset.childOf === parent.dataset.parent) {
                    child.classList.add('active')
                    parentContainer.classList.add('active')
                }
            })
        }
    }
    goToParent () {
        const children = this._elem.querySelectorAll('[data-child-of]')
        const parent = this._elem.querySelector('[data-filter-parents]')
        if (children.length > 0 && parent) {
            children.forEach(child => {
                child.classList.remove('active')
            })
            parent.classList.remove('active')
        }
    }
    applyFilters () {
        const master = window.__Theme.getComponentByName('CollectionFilterMaster')
        if (master) {
            master.applyFilters()
        }
    }
    resetFilters () {
        const filters = this._elem.querySelectorAll('[data-filter-option]')
        if (filters.length > 0) {
            for (var i = 0; i < filters.length; i++) {
                if (filters[i].checked) {
                    filters[i].checked = ''
                }
            }
        }
        this.applyFilters()
    }
    resetOtherFilters (e) {
        const filters = this._elem.querySelectorAll('[data-filter-option]')
        if (filters.length > 0) {
            for (var i = 0; i < filters.length; i++) {
                if (filters[i].checked && filters[i] !== e.currentTarget) {
                    filters[i].checked = ''
                }
            }
        }
    }
}

export default CollectionFilter



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CollectionFilter.js